// extracted by mini-css-extract-plugin
module.exports = {"loadingHolder":"BlockUserModal_loadingHolder__10lUW","errorHolder":"BlockUserModal_errorHolder__2u4Zn"};